import { Typography } from '@mui/material'
import React from 'react'

import { useTranslation } from 'hooks/use-translation'

/**
 * Original intended use is in a Tooltip to display extra scenario info
 * @example <Tooltip title={<TestSuiteScenarioInfo {...props} />}
 */
export const TestSuiteScenarioInfo: React.FC<{
  id: string
  name?: string
  owningTeamLabel?: string
}> = ({ id, name, owningTeamLabel }) => {
  const { trans } = useTranslation()

  return (
    <>
      {name && <Typography variant="body2">{name}</Typography>}
      {owningTeamLabel && (
        <Typography variant="body2">
          {trans('test_suites.test_suite_scenario_info.owner_label')}:{' '}
          {owningTeamLabel}
        </Typography>
      )}
      <Typography variant="body2">
        {trans('test_suites.test_suite_scenario_info.scenario_id_label')}: {id}
      </Typography>
    </>
  )
}
